import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Circle, CircleMarker, Rectangle, Polygon, Polyline } from 'react-leaflet';
import styles from './LeafletLayer.styles';

const useStyles = makeStyles(styles);

const COLOR_MAP = ['red', 'green', 'yellow', 'purple', 'orange', 'pink', 'cyan', 'lightblue'];
const LeafletLayer = ({ layer, onAdded, onClick, isSelected }) => {
  const classes = useStyles();
  if (!layer.shapeType || !layer.enabled) {
    return null;
  }

  const color = COLOR_MAP[layer.sketchAreaId] || 'blue';

  switch (layer.shapeType.toLowerCase()) {
    case 'polygon':
      // A polygon needs at least 3 points to have an area and render a visible shape.
      // Some sketches (e.g. when no building footprint was found) only have a single
      // center point stored, so fall back to a dot marker in that case.
      if (!layer.latLngs || !layer.latLngs.length) {
        return null;
      }

      if (layer.latLngs.length < 3) {
        return (
          <CircleMarker
            layerId={layer.id}
            center={layer.latLngs[0]}
            color={color}
            fillColor={color}
            fillOpacity={1}
            radius={7}
            onAdd={onAdded}
            onclick={onClick}
          />
        );
      }

      return (
        <Polygon
          layerId={layer.id}
          color={color}
          positions={layer.latLngs}
          onAdd={onAdded}
          preferCanvas
          showMeasurements
          measurementOptions={{ imperial: true }}
          onclick={onClick}
          dashArray={isSelected ? '6' : '0'}
          fillOpacity={isSelected ? 0.6 : 0.2}
        />
      );
    case 'polyline':
      return (
        <Polyline
          layerId={layer.id}
          color={color}
          positions={layer.latLngs}
          onAdd={onAdded}
          preferCanvas
          measurementOptions={{ imperial: true }}
          showMeasurements
          // onclick={onClick}
          // dashArray={isSelected ? '6' : '0'}
        />
      );
    case 'rectangle':
      return (
        <Rectangle
          //
          preferCanvas
          bounds={layer.latLngs}
          color={color}
          onclick={onClick}
          dashArray={isSelected ? '6' : '0'}
        />
      );
    default:
      return null;
  }
};

LeafletLayer.propTypes = {
  /** Layer object to render a predefined shape */
  layer: PropTypes.shape({
    latLngs: PropTypes.array,
    shapeType: PropTypes.string,
  }),

  /** Function called when the shape is added to the map */
  onAdded: PropTypes.func,
  onClick: PropTypes.func,
};

export default LeafletLayer;
